<script setup>
import { ref, watch, nextTick } from 'vue'
import api from '../services/api'
import { consentOpen, finishAiConsent } from '../services/aiConsent'
const dialog = ref(null), busy = ref(false), error = ref('')
watch(consentOpen, async open => { await nextTick(); error.value = ''; if(open) dialog.value?.showModal(); else dialog.value?.close() })
async function allow() {
  busy.value = true; error.value = ''
  try {
    const { data } = await api.get('/ai-consent')
    await api.put('/ai-consent', { granted: true, version: data.version })
    finishAiConsent(true)
  } catch { error.value = 'Не удалось сохранить разрешение. Попробуйте ещё раз.' }
  finally { busy.value = false }
}
</script>
<template>
  <dialog ref="dialog" aria-labelledby="ai-consent-title" class="bg-cream text-ink rounded-3xl p-6 w-[calc(100%-24px)] max-w-[406px]" @cancel.prevent="!busy && finishAiConsent(false)">
    <h2 id="ai-consent-title" class="text-20 font-bold mb-4">Чтобы Зоя могла отвечать</h2>
    <p class="text-15 leading-relaxed">Для распознавания еды и персональных ответов мы передаём ваши сообщения, выбранные фотографии, голосовые записи и необходимые сведения о питании и профиле сервису Google Gemini. При технических сбоях текст и изображения может обрабатывать OpenAI.</p>
    <p class="text-14 text-ink/70 mt-3">Не отправляйте документы, контактные данные и другие сведения, по которым вас можно определить. Разрешение можно отозвать в настройках Зои.</p>
    <RouterLink to="/legal/privacy" class="inline-block underline py-3" @click="finishAiConsent(false)">Политика конфиденциальности</RouterLink>
    <p v-if="error" role="alert" class="text-14 mb-3">{{ error }}</p>
    <button class="w-full min-h-12 rounded-2xl bg-ink text-cream px-4 py-3" :disabled="busy" @click="allow">{{ busy ? 'Сохраняю…' : 'Разрешить и продолжить' }}</button>
    <button class="w-full min-h-12 mt-2 rounded-2xl px-4 py-3" :disabled="busy" @click="finishAiConsent(false)">Не сейчас</button>
  </dialog>
</template>
<style scoped>dialog::backdrop { background: rgb(65 41 26 / .4); }</style>
